import { modal } from './globalApp';

type ConfirmActionProps = {
  title: string;
  content?: string | React.ReactNode;
  okText?: string;
  okType?: 'default' | 'primary' | 'danger';
  cancelText?: string;
  cancelType?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  className?: string;
};

export const confirmAction = ({
  title,
  content,
  className,
  okText = 'Confirm',
  okType = 'primary',
  cancelText = 'Cancel',
  cancelType = 'default',
}: ConfirmActionProps): Promise<boolean> => {
  return new Promise((resolve) => {
    modal.confirm({
      title,
      content,
      className,
      okText,
      okType,
      cancelText,
      cancelButtonProps: { type: cancelType },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};
